import type React from "react"

interface ConnectorSectionProps {
  from: string
  to: string
}

const ConnectorSection: React.FC<ConnectorSectionProps> = ({ from, to }) => (
  <div className="review-section connector-section">
    <div className="section-header">
      <h2>Connector</h2>
    </div>
    <div className="connector-display">
      <div className="platform-logo hubspot">
        <img src="https://cdn.worldvectorlogo.com/logos/hubspot-1.svg" alt={from} />
      </div>
      <div className="connector-arrow">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 12h14" />
          <path d="M12 5l7 7-7 7" />
        </svg>
      </div>
      <div className="platform-logo salesforce">
        <img src="https://cdn.worldvectorlogo.com/logos/salesforce-2.svg" alt={to} />
      </div>
    </div>
  </div>
)

export default ConnectorSection
